interface HeaderTitleProps {
  companyName: string;
}

export function HeaderTitle({ companyName }: HeaderTitleProps) {
  return (
    <div className="min-w-0">
      <h1 className="text-2xl sm:text-3xl font-bold text-primary truncate">
        {companyName}
      </h1>
    </div>
  );
}